import { render, staticRenderFns } from "./confirmMobile.vue?vue&type=template&id=2cd79c79&scoped=true"
import script from "./confirmMobile.vue?vue&type=script&lang=js"
export * from "./confirmMobile.vue?vue&type=script&lang=js"
import style0 from "./confirmMobile.vue?vue&type=style&index=0&id=2cd79c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd79c79",
  null
  
)

export default component.exports